import React from "react";
import styled from "styled-components";

const ToastElement = styled.span`
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-bottom: 48px;
  transform: translate(-50%);

  font-family: var(--altFontFamily);
  color: #fff;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
  background-color: rgba(0, 0, 0, 0.75);
  padding: 16px;
  border-radius: 10px;
`;

export const Toast: React.FC<React.ComponentProps<typeof ToastElement>> = (
  props
) => {
  return <ToastElement {...props} />;
};
